let theme = window.theme || {};

const identifyBreakpoint = (width = window.innerWidth) => {
  if (width < theme.breakpoints.tablet) {
    return 'mobile';
  }

  if (width >= theme.breakpoints.tablet && width < theme.breakpoints.laptop) {
    return 'tablet';
  }

  if (width >= theme.breakpoints.laptop && width < theme.breakpoints.desktop) {
    return 'laptop';
  }

  return 'desktop';
};

let previous_breakpoint = identifyBreakpoint();

const breakpoints = () => {
  window.theme.breakpoints.current = previous_breakpoint;

  window.addEventListener('resize', () => {
    const current_breakpoint = identifyBreakpoint();

    if (current_breakpoint !== previous_breakpoint) {
      previous_breakpoint = current_breakpoint;
      window.theme.breakpoints.current = current_breakpoint;
      const breakpointChangeEvent = new CustomEvent('breakpointChange', { detail: current_breakpoint });
      window.dispatchEvent(breakpointChangeEvent);
      // Fire a scroll event to trigger any animations that might need to happen on a breakpoint change
      window.dispatchEvent(new Event('scroll'));
    }
  });
};

export { breakpoints };
